import { get } from "lodash";

export default class Size {
  id?: string;
  name: string;
  width: number;
  height: number;
  description?: string;

  constructor(params?: Size) {
    this.id = get(params, "id", undefined);
    this.name = get(params, "name", "");
    this.width = get(params, "width", 0);
    this.height = get(params, "height", 0);
    this.description = get(params, "description");
  }
}
